import {DeviceDetectorService} from 'ngx-device-detector'
import {Component, Input, OnInit} from '@angular/core'
import * as moment_ from 'moment'
import {DateFormatService, RichsnipetService} from 'dmmp-services'
import {map} from 'rxjs/operators'

@Component({
  selector: 'dmmp-website-course-detailed-tabs-v2',
  templateUrl: './website-course-detailed-tabs-v2.component.html'
})
export class WebsiteCourseDetailedTabsV2Component implements OnInit {
  moment = moment_
  @Input() layout
  @Input() module
  @Input() identifier
  schema = []

  constructor(
    private dateService: DateFormatService,
    public deviceDetectorService: DeviceDetectorService,
    private richsnipetService: RichsnipetService) {
  }

  ngOnInit() {
    if (this.layout?.items?.length > 0) {
      this.layout?.items?.forEach(item => {
        if (item?.options?.length > 0) {
          item?.options?.filter(res => {
            if (res?.identifier === 'program_video' && res?.video?.length > 0) {
              if (res?.video[0]?.type === 'youtube') {
                const video = res?.video[0]?.video[0]?.value
                this.richsnipetService.getInfoVideo(video.substr(video.indexOf('v=') + 2, video?.length)).pipe(
                  map((data: any) => {
                    if (data) {
                      this.createRichSnipet(res, data?.items[0]?.contentDetails?.duration)
                    }
                  })
                ).subscribe()
              } else {
                this.createRichSnipet(res)
              }
            }
          })
        }
      })
    }
  }

  createRichSnipet(res, duration: string = '') {
    this.schema.push(this.richsnipetService.setupJsonVideo(
      res?.video[0]?.title || '',
      res?.video[0]?.description || '',
      res?.video[0]?.image[0]?.styles?.large || '',
      res?.video[0]?.created_at ? this.dateService.convertFromTimestampToDate(res?.video[0]?.created_at) : '',
      res?.video[0]?.video[0]?.value || '',
      duration || ''))
  }
}
